import { render } from "./product_item_relations.vue?vue&type=template&id=5d8d0ba6"
import script from "./product_item_relations.vue?vue&type=script&setup=true&lang=js"
export * from "./product_item_relations.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/product_item_relations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d8d0ba6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d8d0ba6', __exports__)) {
    api.reload('5d8d0ba6', __exports__)
  }
  
  module.hot.accept("./product_item_relations.vue?vue&type=template&id=5d8d0ba6", () => {
    api.rerender('5d8d0ba6', render)
  })

}


export default __exports__